import React from 'react';
import { Link } from "react-router-dom";

const CategoryCard = (props) => {
    return (
        <div className='pcard'>
            <div className="productImg">
                <Link to={props.Childs?.length > 0 ? `/categorie/${props.CatSlug}` : `/product/categories/${props.CatSlug}`}>
                    <img src={props.ImgUrl} alt={props.Name} title={props.Name} />
                </Link>
            </div>
            <div className="categorycard-content">
                <Link to={props.Childs?.length > 0 ? `/categorie/${props.CatSlug}` : `/product/categories/${props.CatSlug}`}><p>{props.Name.toLowerCase()}</p></Link>
            </div>
        </div>

    )
}

export default CategoryCard;